import UserApi from '@/api/user/UserApi';

const formatIcon = (icon) => {
  if (!icon) {
    return '';
  }
  return icon.includes('mb-2') ? icon : `${icon} mb-2`;
};

const state = {
  items: []
};

const mutations = {
  setMenuItems(state, items) {
    state.items = items;
  }
};

const actions = {
  async fetchMenuItems({ commit }) {
    try {
      const response = await UserApi.userSettingMenuItems();
      const menuItems = Array.isArray(response?.data) ? response.data : [];
      const normalizedItems = menuItems
        .map(item => ({
          id: item?.id?.toString() ?? '',
          title: item?.title ?? '',
          icon: formatIcon(item?.icon)
        }))
        .filter(item => item.id);

      commit('setMenuItems', normalizedItems);
    } catch (error) {
      console.error('failed to fetch menu items', error);
    }
  }
};

const getters = {
  getMenuItems: (state, getters, rootState, rootGetters) => {
    return state.items.map(item => ({
      ...item,
      title: typeof rootGetters.t === 'function' ? rootGetters.t(item.title) : item.title
    }));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 
